import SearchIcon from '@mui/icons-material/Search';

export const routes = [
  {
    path: '/annonces',
    name: 'Trouver un stage',
    icon: SearchIcon,
  },
];
